var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('login-register',{attrs:{"formSubmit":_vm.formSubmit,"formRender":_vm.formRender}})}
var staticRenderFns = []

export { render, staticRenderFns }